import React from 'react'
import styled from 'styled-components'
import { I18n } from '@lingui/react'
import {
  Thirds, Left, Right,
  TimeFramePicker,
  DisplayMedium, DisplaySmall,
  Back,
  spacing, color
} from '@conserveit/blocks'
import { TimeFrame } from '../../../../context/reports/utilities/types'
import { getTimeFrameList, getTimeFrameRange } from '../utils'
import { setPersisted } from '../../../../utils/storage'
import { TIMEFRAME_PERSIST_PROP } from '../../../../context/reports/utilities/constants'
import { navigate } from '../../../../utils/routes/navigate'
import { Wrap } from '../../../Layout/Page'

const SubTitle = styled(DisplaySmall)`
  color: ${color.theme.typography.subdued};
  margin-bottom: ${spacing.extraTight};
`

const StyledThirds = styled(Thirds)`
  ${Left} {
    flex-direction: column;
  }
`

const HeadWrap = styled(Wrap)`
  padding: ${spacing.default} ${spacing.extraLoose};
`

const GoBack = styled(Back)`
  margin-bottom: ${spacing.extraTight};
`
interface Props {
  subTitle?: string
  groupPrefix?: string
  groupName?: string
  showBackTo?: boolean
  backTo?: string
  defaultTimeFrame: TimeFrame
  onTimeFrameChange: (timeFrameOption: TimeFrame, startDate: string, endDate: string) => void
  persistKey: string
}

export const HeadBar: React.FC<Props> = ({
  subTitle,
  groupPrefix,
  groupName,
  defaultTimeFrame,
  onTimeFrameChange,
  backTo,
  persistKey
}) => {
  const handleTimeFrame = React.useCallback((option: { value: string | number }) => {
    const value = option.value as TimeFrame
    const { startDate, endDate } = getTimeFrameRange(value)
    // Persist selected option in session storage
    setPersisted({ prop: TIMEFRAME_PERSIST_PROP, key: persistKey }, value)
    onTimeFrameChange(value, startDate, endDate)
  }, [])

  return (
    <I18n>
      {({ i18n }) => {
        const options = getTimeFrameList(i18n)
        const defaultOption = options.find(option => option.value === defaultTimeFrame) || options[0]
        return (
          <HeadWrap>
            <StyledThirds>
              <Left>
                {backTo && <GoBack text='back to Previous' onClick={navigate(backTo)} />}
                {subTitle && <SubTitle>{subTitle}</SubTitle>}
                <DisplayMedium>{groupPrefix ? `${groupPrefix}: ` : ''}{groupName ? groupName : ' Portfolio view'}</DisplayMedium>
              </Left>
              <Right>
                <TimeFramePicker
                  actionHeading='TIME FRAME'
                  defaultValue={defaultOption}
                  actionList={options}
                  onApply={handleTimeFrame}
                />
              </Right>
            </StyledThirds>
          </HeadWrap>
        )
      }}
    </I18n>
  )
}
